

































































































































































import { Component, Vue } from "vue-property-decorator";
import TaxEventPayload from "@/dto/tax/TaxEventPayload";
import TaxEventService from "@/services/TaxEventService";
import SimpleProfileSearch from "@/components/common/SimpleProfileSearch.vue";
import DictionarySelect from "@/components/common/DictionarySelect.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import ProfileDTO from "@/dto/profile/ProfileDTO";
import Application from "@/state/Application";
import { processError } from "@/utils/ComponentUtils";
import { YEARS, Period } from "@/constants/DateTimeConstants";
import { TaxEventStatus } from "@/constants/TaxEventStatus";
import { PaymentStatus } from "@/constants/PaymentConstants";
import { Risk } from "@/constants/Risk";
import SelectOption from "@/components/common/SelectOption";
import SublimeSearch from "@/components/common/SublimeSearch.vue";
import SublimeEmployeeDTO from "@/dto/sublime/employee/SublimeEmployeeDTO";

@Component({
  components: {
    SimpleProfileSearch,
    DictionarySelect,
    PortalInput,
    PortalSelect,
    SublimeSearch
  }
})
export default class CreateTaxEventModal extends Vue {
  
  private form: Partial<TaxEventPayload> = {};
  private amountLocal: number | string = '';
  private customerProfile: ProfileDTO | null = null;
  private assignee: SublimeEmployeeDTO | null = null;

  public beforeOpen(): void {
    this.form = {
      year: new Date().getFullYear(),
      period: null as any,
      dueDate: '',
      eventDate: '',
      paidOn: null,
      amountCents: 0,
      status: TaxEventStatus.SCHEDULED,
      paymentStatus: PaymentStatus.UNPAID,
      risk: Risk.LOW,
      obligation: '',
      nextAction: '',
      taxTypeId: null as any,
      customerId: null as any,
      customerType: null as any,
      assigneeId: null as any
    };
    this.amountLocal = '';
    this.customerProfile = null;
    this.assignee = null;
    // reset validation if vee-validate is used
    if (this.$validator) {
      this.$validator.reset();
    }
  }

  public closeModal(): void {
    this.$modal.hide('create-tax-event-modal');
  }

  public onCustomerSelected(profile: ProfileDTO | null): void {
    if (profile) {
      this.form.customerId = profile.id;
      this.form.customerType = profile.type as any;
    } else {
      this.form.customerId = null as any;
      this.form.customerType = null as any;
    }
  }
  
  public onAssigneeSelected(employee: SublimeEmployeeDTO | null): void {
    this.assignee = employee;
    if (employee) {
      this.form.assigneeId = employee.id;
    } else {
      this.form.assigneeId = null as any;
    }
  }
  
  get isValid(): boolean {
    if (this.$validator && this.$validator.errors.items.length > 0) return false;
    return !!(this.form.customerId && this.form.taxTypeId && this.amountLocal && this.form.eventDate && this.form.year && this.form.period && this.form.dueDate);
  }

  get yearOptions() {
    return YEARS.map(year => SelectOption.builder().title(`${year}`).value(year).build());
  }

  get periodOptions() {
    return Object.values(Period).map(period => SelectOption.builder().title(this.$stringUtils.enumToFormattedSentence(period)).value(period).build());
  }

  get statusOptions() {
    return Object.values(TaxEventStatus).map(val => SelectOption.builder().title(this.$stringUtils.enumToFormattedSentence(val)).value(val).build());
  }

  get paymentStatusOptions() {
    return Object.values(PaymentStatus).map(val => SelectOption.builder().title(this.$stringUtils.enumToFormattedSentence(val)).value(val).build());
  }

  get riskOptions() {
    return Object.values(Risk).map(val => SelectOption.builder().title(this.$stringUtils.enumToFormattedSentence(val)).value(val).build());
  }

  public async submit(): Promise<void> {
    const valid = await this.$validator.validateAll();
    if (!valid || !this.isValid) return;

    if (this.amountLocal) {
        this.form.amountCents = Math.round(parseFloat(this.amountLocal.toString()) * 100);
    }

    this.$loadOn();
    try {
      await TaxEventService.createTaxEvent(this.form as TaxEventPayload);
      this.closeModal();
      this.$emit('created');
    } catch (e) {
      processError(e, this);
    } finally {
      this.$loadOff();
    }
  }
}
